import React from "react";
import styled from "@emotion/styled";
import { DataTable as BaseDataTable, DataTableProps } from "../DataTable";
import { Wrapper } from "../Wrapper";

const DataTable = styled(BaseDataTable)`
  margin-bottom: 60px;
`;

export const DataTableWidget = (props: DataTableProps) => (
  <Wrapper>
    <DataTable {...props} />
  </Wrapper>
);
